// extracted by mini-css-extract-plugin
export default {"sub_header":"MobileSubheading_sub_header__3Cs5p"};